import { SyncNowModal} from "./SyncNowModal";

export default SyncNowModal;
